'use client';
import Link from 'next/link';
import type { SearchAskAnswerPart, SearchAskSource } from '../../../src/shared/siteSearch';

/** The Ask AI answer, shared by the command palette and Guides: plain runs as text, and a run that names
 *  a cited page as a link to that page. The URL is the retrieved source's, never generated text. */
export function AskAnswerText({ parts, sources, className, linkClassName, onNavigate }: {
  parts: SearchAskAnswerPart[];
  sources: SearchAskSource[];
  className: string;
  linkClassName: string;
  onNavigate?: () => void;
}) {
  return <p className={className}>{parts.map((part, index) => {
    if (part.source === undefined) return part.text;
    const source = sources[part.source];
    // The daemon numbers every linked run from the sources it returns with it (siteSearchAsk.ts).
    if (!source) throw new Error(`Ask answer links to missing source ${part.source}`);
    return <Link key={index} href={source.href} lang={source.locale} onNavigate={onNavigate} className={linkClassName}>{part.text}</Link>;
  })}</p>;
}
